var chunkToChildrenMap = {
	"6461": [
		1869,
		5113
	],
	"6477": [
		1869,
		5113
	],
	"6829": [
		1869,
		5113
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));